var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "copyModal" },
    [
      _c(
        "Modal",
        {
          attrs: { width: "360", mask: true },
          model: {
            value: _vm.copyModal,
            callback: function ($$v) {
              _vm.copyModal = $$v
            },
            expression: "copyModal",
          },
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                color: "black",
                "font-size": "13px",
                "text-align": "center",
              },
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v("复制权限")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c("FormLayout", {
                ref: "FormLayout",
                attrs: {
                  defaultColumn: _vm.defaultColumn,
                  defaultconfig: _vm.config,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "fcdefault", size: "small" },
                  on: { click: _vm.sureBtn },
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { type: "fcdefault", size: "small" },
                  on: { click: _vm.cancelBtn },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }